interface IProjection {
    min: number;
    max: number;
}

export default class Projection {
    min = 0;
    max = 0;
    constructor(min: number, max: number) {
        this.min = min;
        this.max = max;
    }
    overlaps(projection: IProjection) {
        return this.max > projection.min && projection.max > this.min;
    }
}
